import React from 'react'
import { Link } from 'react-router-dom'

export default function Carrots() {
  return <>
    <div className="container-fluid bg-primary py-5 bg-prd4 mb-5">
      <div className="container py-5">
        <div className="row justify-content-start">
          <div className="col-lg-8 text-center text-lg-start">
            <h1 className="display-1 text-white mb-md-4">Carrots </h1>
            <Link to="/fresh-products" className="btn btn-primary py-md-3 px-md-5 me-3">fresh products </Link>
            <Link to="" className="btn btn-secondary py-md-3 px-md-5">Carrots </Link>
          </div>
        </div>
      </div>
    </div>

    <div className="container py-5">
      <div className='mb-5'>
        <h2 className='text-primary'> Carrots</h2>
        <h5 className='text-muted'> Carrots are root vegetables known for their orange color and delicious taste. <br />
          They are renowned for their high content of vitamin A.

        </h5>
      </div>

      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Varieties:</h5>
        <h5 className=' mt-3'> La gouna F1
        </h5>
        <h5 className=' mt-3'> Navel
        </h5>
        <h5 className=' mt-3'>   Nairboi</h5>
      </div>
      <hr />
      <hr />
          <h2 className='text-primary my-3'>Season:</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>-In Egypt,  typically runs from Jun. to May.
          </h5>
        </li>


      </ul>
      <hr />

      <h2 className='text-primary my-3'>Packing</h2>

      <ul className='mb-5'>
        <li className="my-2">
          <i className="fa-regular fa-circle-check text-success mx-2"></i><h5 className='d-inline'>Plastic bags 
          Weight: 10 -18 kgs
            containing 180 cartons.
          </h5>
        </li>

      </ul>
      <div className='my-5'>
        <i className="me-3  text-success  fa-regular fa-circle-check"></i>
        <h5 className=' d-inline mb-3'>Size:</h5>
        <h5 className=' mt-3'> (80-150g; 150-200g; 200-250g; 250-300)</h5>
      </div>
      <hr />

      <Link to="/contact" className="btn bg-primary text-light py-3 px-5">Get Offer</Link>

    </div>
  </>
}
